import { Box } from '@chakra-ui/react';

import { DownloadIcon } from 'Asset/icon';
import { ReportAttendanceHostDetailText } from 'Const/report-attendance-host-detail/view';
import useGetAttendanceHostStatus from 'Domain/report-attendance-host-detail/useGetAttendanceHostStatus';
import useGetExportReportAttendanceHostDetail from 'Domain/report-attendance-host-detail/useGetExportReportAttendanceHostDetail';
import FilterDatepicker from 'UiKit/filter-datepicker';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import FilterSelect from 'UiKit/filter-select';
import ButtonSolid from 'UiKit/button/buttonSolid';

import { useReportAttendanceHostDetailState } from 'View/report-attendance-host-detail/state';

import styles from './styles.module.css';

const Filter = ({ userId, t }) => {
  const { filterState, updateFilterState } = useReportAttendanceHostDetailState();
  const { data: statusOptions } = useGetAttendanceHostStatus();
  const { mutate } = useGetExportReportAttendanceHostDetail();

  const handleFilter = ({ field, value }) => {
    updateFilterState({
      ...filterState,
      [field]: value,
    });
  };

  const handleExport = () => mutate({ ...filterState, userId });

  return (
    <Box className={styles['filter__container']}>
      <Box className={styles['filter__field--container']}>
        <Box className={`${styles['filter__item--date-range']}`}>
          <FilterDatepicker value={filterState?.startedAt} onChange={(value) => handleFilter({ field: 'startedAt', value })} />
          <TextRegular>-</TextRegular>
          <FilterDatepicker value={filterState?.endedAt} onChange={(value) => handleFilter({ field: 'endedAt', value })} />
        </Box>
        <FilterSelect
          placeholder={t('filter.selectStatus')}
          value={filterState?.status}
          clearable={true}
          width="168px"
          options={statusOptions || []}
          counterLabel={'Status'}
          onChange={(value) => handleFilter({ field: 'status', value })}
          isMulti
        />
      </Box>
      <ButtonSolid className={styles['filter__button-export']} onClick={handleExport}>
        <DownloadIcon size="14px" />
        <TextSemiBold className={styles['filter_button-export--text']}>{ReportAttendanceHostDetailText.buttonExportText}</TextSemiBold>
      </ButtonSolid>
    </Box>
  );
};

export default Filter;
